import { c as _c } from "react/compiler-runtime";
import type { AdvancedMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Field, Fieldset, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input/Input';
import { Slider } from '@algoacademy/design-system/web/forms/Slider/Slider';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading/H4';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import type { ChangeEvent } from 'react';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import { MAXIMUM_HOURS_WITH_MENTOR, MINIMUM_HOURS_WITH_MENTOR } from '../../../prices';
type HoursWithMentorProps = {
  advancedMentoringProduct: AdvancedMentoringProductDTO;
  updateProduct: (updates: Partial<AdvancedMentoringProductDTO>) => void;
};
export function HoursWithMentor(t0) {
  const $ = _c(21);
  const {
    advancedMentoringProduct,
    updateProduct
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H4 className="font-medium">Konsultacje indywidualne z mentorem</H4>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <P2 className="text-contentSecondary">Wybierz liczbę godzin indywidualnych konsultacji z mentorem miesięcznie. Mentor przygotowuje się do każdej konsultacji i zapewnia najwyższą efektywność spotkań.</P2>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== advancedMentoringProduct.hoursWithMentor) {
    t3 = [advancedMentoringProduct.hoursWithMentor];
    $[2] = advancedMentoringProduct.hoursWithMentor;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== updateProduct) {
    t4 = value => updateProduct({
      hoursWithMentor: value[0]
    });
    $[4] = updateProduct;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Slider variant="single" min={MINIMUM_HOURS_WITH_MENTOR} max={MAXIMUM_HOURS_WITH_MENTOR} step={1} value={t3} onValueChange={t4} />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex flex-row justify-between text-slate-600 text-sm"><p>{MINIMUM_HOURS_WITH_MENTOR}</p><p>{MAXIMUM_HOURS_WITH_MENTOR}</p></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className="flex w-full flex-col gap-2 sm:flex-1">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Label>Liczba godzin</Label>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== updateProduct) {
    t9 = e => {
      let hours = Number(e.target.value);
      if (hours < MINIMUM_HOURS_WITH_MENTOR) {
        hours = MINIMUM_HOURS_WITH_MENTOR;
      }
      if (hours > MAXIMUM_HOURS_WITH_MENTOR) {
        hours = MAXIMUM_HOURS_WITH_MENTOR;
      }
      updateProduct({
        hoursWithMentor: hours
      });
    };
    $[13] = updateProduct;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== advancedMentoringProduct.hoursWithMentor || $[16] !== t9) {
    t10 = <Fieldset className="w-full sm:w-36"><Field>{t8}<Input value={advancedMentoringProduct.hoursWithMentor} onChange={t9} type="number" /></Field></Fieldset>;
    $[15] = advancedMentoringProduct.hoursWithMentor;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <IconOnTheLeftWithContentLayout mainContent={t1}><div className="space-y-6 sm:space-y-2">{t2}<div className="flex flex-col items-end gap-2 sm:flex-row sm:gap-6">{t7}{t10}</div></div></IconOnTheLeftWithContentLayout>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}